import { createSerializedApiError } from '../../app/utils/createSerializedApiError';

export function normalizeErrorsInterceptor(error: unknown): Promise<never> {
  return Promise.reject(createSerializedApiError(error));
}
